import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { layout } from "@universityofmaryland/web-styles-library";
import * as token from "@universityofmaryland/web-token-library";
function createLayoutGridBorder({
  columns = 2,
  isThemeDark = false,
  enableContainerQueries = false,
  alignItems
} = {}) {
  let gridStyle = isThemeDark ? layout.grid.border.columnsTwoDark : layout.grid.border.columnsTwo;
  if (columns === 3) {
    gridStyle = isThemeDark ? layout.grid.border.columnsThreeDark : layout.grid.border.columnsThree;
  } else if (columns === 4) {
    gridStyle = isThemeDark ? layout.grid.border.columnsFourDark : layout.grid.border.columnsFour;
  }
  const containerQueryStyles = enableContainerQueries ? {
    containerType: "inline-size"
  } : {};
  const alignmentMap = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    stretch: "stretch"
  };
  const alignmentStyles = alignItems ? { alignSelf: alignmentMap[alignItems] } : {};
  return new ElementBuilder().styled(gridStyle).withStyles({
    element: {
      [` > *`]: {
        ...alignmentStyles,
        padding: token.spacing.xl,
        ...containerQueryStyles
      }
    }
  }).build();
}
export {
  createLayoutGridBorder
};
//# sourceMappingURL=grid-border.js.map
